import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import styled from 'styled-components';
import { Colors } from '../../../../../assets';
import { Spacing } from '../../../../../assets/GlobalStyle/Variables';
import { RequestsFormValues } from '../../models';

export const TryptaseForm: FC = () => {
  const { register } = useFormContext<RequestsFormValues>();

  return (
    <Wrapper>
      <Check>
        <input type="checkbox" {...register('tryptase.do_request')} />
        <span>Poslat žádost o tryptázu</span>
      </Check>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding: ${Spacing(2)} 0;
`;

const Check = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  user-select: none;

  input[type='checkbox'] {
    width: 16px;
    height: 16px;
  }

  span {
    color: ${Colors.grey};
  }
`;
